import { FC } from 'react'
import App from './components/app/app'
import { AppProps } from './components/app/app'

interface StampWriteOffFormProps extends AppProps {}

const StampWriteOffForm: FC<StampWriteOffFormProps> = props => {
    return <App {...props} />
}

export default StampWriteOffForm
